/**
  * 深色背景用 饼图
  * @param unit 单位
  * @param dataArr [{name:'',value:0}]数据合集
*/
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let color = ["#28CCCB", "#59A3F3", "#94B794", "#AE9AF3", "#819CEC"];
  let option = {
    color: color,
    tooltip: {
      trigger: "item",
      formatter:function(param){
        return `${param.name}:${dealBigNum(param.value)}${paramObj.unit} ${param.percent == undefined?0:param.percent}%`
      }
    },
    series: [
      {
        type: "pie",
        roseType: "radius",
        radius: ["25%", "60%"],
        center: ["50%", "50%"],
        data: paramObj.dataArr,
        itemStyle: {
          borderColor: "#fff",
          borderWidth: 2,
        },

        labelLine: {
          length: 20,
          length2: 30,
        },
        label: {
          formatter: (params) => {
            return (
              "{icon|●}{name|" +
              params.name +
              "}" +
              (params.percent == undefined ? 0 : params.percent) +
              "%\n{value|" +
              dealBigNum(params.value) + paramObj.unit +
              "}"
            );
          },
          rich: {
            icon: {
              fontSize: 12,
              color: "inherit",
            },
            name: {
              fontSize: 12,
              padding: [0, 0, 0, 10],
              color: "#000",
            },
            value: {
              fontSize: 12,
              fontWeight: "bolder",
              padding: [10, 0, 0, 20],
              color: "inherit",
            },
          },
        },
        animation: false,
      },
    ],
  };
  return option
  
}